(function (itxApp) {
    'use strict';

    angular.module('itxApp.common').filter('mdUppercase', mdUppercaseFlt);

    mdUppercaseFlt.$inject = ['mdUtils'];

    function mdUppercaseFlt(mdUtils) {
        return function (value) {
            return mdUtils.upperCaseText(value);
        };
    }
})();
